/**
 * File -> base64 conversion for APIs that take image bytes inline.
 *
 * The conversion was previously copy-pasted into `pages/organizations/add.tsx`
 * (keeping the data URL) and `components/StationIconUpload.tsx` (stripping it).
 * Both forms are here so callers stop reimplementing them.
 */

/** Resolves to a full data URL, e.g. `data:image/png;base64,iVBOR...`. */
export function toDataUrl(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

/**
 * Resolves to the raw base64 payload with the `data:...;base64,` prefix
 * removed — the form GraphQL string arguments expect.
 */
export async function toBase64(file: Blob): Promise<string> {
  const dataUrl = await toDataUrl(file);
  return dataUrl.slice(dataUrl.indexOf(',') + 1);
}
